import { ICreateOrderDataDTO } from "@modules/orders/dtos/ICreateOrderDataDTO";
import {
  AtemStatus,
  CreateOrderResultUI,
  OrderStatusUI,
} from "../../model/order.model";
import { CartItem } from "../../model/product.cart.model";

export function toCreateOrderResponse(
  dto: ICreateOrderDataDTO,
  cart?: CartItem[]
): CreateOrderResultUI {
  const created = dto.response
    .filter((x) => x.status === "success" && Boolean(x.numberOrder))
    .map((x) => ({
      orderCode: x.numberOrder!,
      deliveryDateISO: x.deliveryDate,
      implantationDateISO: x.implantationDate,
      productId: x.product.id,
      quantityLiters: x.product.quantity,
      paymentLabel: paymentLabelFrom(
        x.product.payment,
        x.product.deadlinePayment
      ),
      status: statusFromAtem(x.atemStatus),
      price:
        x.product.price ??
        cart?.find((c) => c.code === x.product.id)?.unitPrice,
    }));

  const failed = dto.response
    .filter((x) => x.status === "error")
    .map((x) => ({
      productId: x.product.id,
      quantityLiters: x.product.quantity,
      message: x.error ?? "Falha ao criar a ordem de venda",
    }));

  const overall: CreateOrderResultUI["overall"] =
    created.length > 0 && failed.length > 0
      ? "PARCIAL"
      : created.length > 0
      ? "SUCESSO"
      : "ERRO";

  return { ok: true, overall, created, failed, raw: dto };
}

function paymentLabelFrom(code: string, deadlinePayment?: number) {
  if (code === "T") return "À vista";
  if (code === "B") {
    if (deadlinePayment === 1) return "1 dia";
    if (deadlinePayment !== undefined && deadlinePayment > 1)
      return `${deadlinePayment} dias`;

    return "Boleto";
  }
  return code;
}

function statusFromAtem(atemStatus?: AtemStatus): OrderStatusUI {
  if (atemStatus === "BL") return "BLOQUEADO";
  if (atemStatus === "LIB") return "LIBERADO";
  // fallback seguro (quando não vem)
  return "LIBERADO";
}
